import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import Breadcrumb from '../../components/Breadcrumb';
import type { VersionSummary } from '@shared/types';

export default function AdminHistory() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'versions'],
    queryFn: () => api.get<{ versions: VersionSummary[] }>('/versions'),
  });

  return (
    <div>
      <Breadcrumb items={[{ label: 'Admin' }, { label: 'Historie verzí' }]} />
      <h1 className="mb-8 font-heading text-3xl font-bold text-dark">Historie verzí</h1>

      {isLoading && <div className="text-sm text-gray-500">Načítám…</div>}

      {data && data.versions.length === 0 && (
        <div className="card p-12 text-center text-gray-500">Zatím žádné publikované verze.</div>
      )}

      <div className="space-y-3">
        {data?.versions.map((v) => (
          <div key={v.id} className="card p-5">
            <div className="mb-2 flex items-center justify-between">
              <div className="font-heading text-xl font-bold text-dark">v{v.number}</div>
              <div className="text-xs text-gray-500">
                {new Date(v.publishedAt * 1000).toLocaleString('cs-CZ')}
              </div>
            </div>
            {v.releaseNote && <p className="mb-3 text-sm text-gray-600">{v.releaseNote}</p>}
            <div className="text-xs text-gray-500">
              {v.changelog.length} {v.changelog.length === 1 ? 'změna' : 'změn'} —
              {' '}
              {v.changelog.filter((c) => c.type === 'added').length} nových,
              {' '}
              {v.changelog.filter((c) => c.type === 'modified').length} upravených,
              {' '}
              {v.changelog.filter((c) => c.type === 'deleted').length} smazaných
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
